import { infiniteQueryOptions, mutationOptions } from "@tanstack/react-query";
import {
  GET_UTAGE_WEB_BOARD_MESSAGE,
  POST_SESSION_BOARD_MESSAGE,
} from "~/constants/apiEndpoints";
import { apiClient } from "~/lib/apiClient";
import { queryClient } from "~/lib/queryClient";
import { queryKeys } from "~/lib/queryKeys";
import type {
  BoardFilter,
  BoardMessageListResponse,
  PostBoardRequest,
} from "./types";
export const BOARD_PAGE_SIZE = 20;
export const BOARD_MESSAGE_MAX_LENGTH = 100;
// サーバー側の投稿レート制限（5分）と一致させる
export const BOARD_POST_INTERVAL_MS = 5 * 60 * 1000;
export const BOARD_RATE_LIMIT_CODE = 75;

export const buildBoardListBody = (skip: number) => {
  return { skip };
};

export const boardMessagesInfiniteQueryOptions = (filter: BoardFilter) =>
  infiniteQueryOptions({
    queryKey: queryKeys.board.list(filter),
    queryFn: ({ pageParam }) =>
      apiClient<BoardMessageListResponse>(
        GET_UTAGE_WEB_BOARD_MESSAGE,
        buildBoardListBody(pageParam),
      ),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.length < BOARD_PAGE_SIZE) {
        return undefined;
      }
      return allPages.reduce((sum, page) => sum + page.length, 0);
    },
  });

export const postBoardMessageMutationOptions = mutationOptions({
  mutationFn: (data: PostBoardRequest) =>
    apiClient<unknown>(POST_SESSION_BOARD_MESSAGE, {
      message: data.message,
      is_from_web: true,
    }),
  onSuccess: () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.board.lists() });
  },
});
